import { Route } from 'react-router-dom';
import WrongUserRole from '../components/account-login/wrong-user-role';

export const WrongUserRouter = () => {
  return <Route component={WrongUserRole} path="*" />;
};
